import React, { useState, useEffect } from "react";
import { Table, Input } from "antd";
import { getMonthlyCounterparty } from "../../../../../api/EmiPayments";
import { useSelector } from "react-redux";
import { CURRENCY } from '../../../../../utils/ConstantData';
import CustomAmountText from "../../../../common/CustomAmountText";

const { Search } = Input;



const MonthlyCounterparty = () => {
  const [monthlyCounterparty, setMonthlyCounterparty] = useState([]);
  const [dynamicColumns, setDynamicColumns] = useState([]);
  const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);



  // Static columns for Counterparty, Credit, Credit Transaction, Debit, and Debit Transaction in "Total (Jan 2020 - Dec 2020)"
  const staticColumns = [
    {
      title: 'CounterParty',
      dataIndex: 'counterparty',
      key: 'counterparty',
      width: 150,
    },
    // {
    //   title: `Debit (${CURRENCY})`,
    //   dataIndex: 'totalDebitAmount',
    //   key: 'totalDebitAmount',
    //   width: 150,
    // },
    // {
    //   title: `Debit Transaction`,
    //   dataIndex: 'totalDebitTransaction',
    //   key: 'totalDebitTransaction',
    //   width: 150,
    // },
    // {
    //   title: `Credit (${CURRENCY})`,
    //   dataIndex: 'totalCreditAmount',
    //   key: 'totalCreditAmount',
    //   width: 150,
    // },
    // {
    //   title: `Credit Transaction`,
    //   dataIndex: 'totalCreditTransaction',
    //   key: 'totalCreditTransaction',
    //   width: 150,
    // }
  ];



  // List of months for columns
  const months = [
    'Jan 2020', 'Feb 2020', 'Mar 2020', 'Apr 2020', 'May 2020',
    'Jun 2020', 'Jul 2020', 'Aug 2020', 'Sep 2020', 'Oct 2020',
    'Nov 2020', 'Dec 2020'
  ];

  // Create monthly columns with Debit, Debit Transaction, Credit, Credit Transaction
  const monthlyColumns = months.map(month => ({
    title: month,
    children: [
      { title: `Debit (${CURRENCY})`, dataIndex: `${month.toLowerCase()}DebitAmount`, key: `${month.toLowerCase()}DebitAmount`, width: 150 },
      { title: `Debit Transaction`, dataIndex: `${month.toLowerCase()}DebitTransaction`, key: `${month.toLowerCase()}DebitTransaction`, width: 150 },
      { title: `Credit (${CURRENCY})`, dataIndex: `${month.toLowerCase()}CreditAmount`, key: `${month.toLowerCase()}CreditAmount`, width: 150 },
      { title: `Credit Transaction`, dataIndex: `${month.toLowerCase()}CreditTransaction`, key: `${month.toLowerCase()}CreditTransaction`, width: 150 },
    ]
  }));

  if (selectedAccountId === "all") {
    staticColumns.splice(1, 0, {
      title: 'Bank Account',
      dataIndex: 'mappedAccount',
      key: 'mappedAccount',
      width: 150,
    })
  }

  // Combine static "Total" columns with monthly columns
  const columns = [...staticColumns, ...dynamicColumns];


  console.log("Monthly counter party column>>>", columns, monthlyCounterparty);


  useEffect(() => {
    const fetchData = async (accountId) => {
      try {

        let aggregate = accountId !== 'all' ? false : true;
        let account_id = accountId !== 'all' ? accountId : reportDetails?.report?.reportId;
        const response = await getMonthlyCounterparty(account_id, aggregate);
        const months = extractMonthsFromResponse(response.counterparties);
        const transformedData = transformCounterpartyData(response.counterparties, months);
        setMonthlyCounterparty(transformedData);
        setDynamicColumns(generateColumnsBasedOnResponse(months));
      } catch (error) {
        console.error("Error fetching monthly counterparty data", error);
      }
    };

    if (selectedAccountId) {
      fetchData(selectedAccountId);
    }
  }, [selectedAccountId]);


  const extractMonthsFromResponse = (counterparties) => {
    return counterparties[0]?.data.map(item => item.month) || [];
  };


  const transformCounterpartyData = (counterparties, months) => {
    return counterparties.map(counterparty => {

      console.log("COUNTER PARTIES::", counterparty);
      const row = {
        counterparty: counterparty.counterparty,
        mappedAccount: counterparty.data.find(d => d).mappedAccount.find(i => i).accountString,
        totalDebitAmount: counterparty.data.find(d => d.month === "Total (Jan 2020 - Dec 2020)")?.debitAmount || 0,
        totalDebitTransaction: counterparty.data.find(d => d.month === "Total (Jan 2020 - Dec 2020)")?.debitTxnCount || 0,
        totalCreditAmount: counterparty.data.find(d => d.month === "Total (Jan 2020 - Dec 2020)")?.creditAmount || 0,
        totalCreditTransaction: counterparty.data.find(d => d.month === "Total (Jan 2020 - Dec 2020)")?.creditTxnCount || 0,
      };

      months.forEach(month => {
        if (month.includes("Total")) {
          row['totalDebitAmount'] = counterparty.data.find(d => d.month.includes("Total"))?.debitAmount || 0;
          row['totalDebitTransaction'] = counterparty.data.find(d => d.month.includes("Total"))?.debitTxnCount || 0;
          row['totalCreditAmount'] = counterparty.data.find(d => d.month.includes("Total"))?.creditAmount || 0;
          row['totalCreditTransaction'] = counterparty.data.find(d => d.month.includes("Total"))?.creditTxnCount || 0;
        } else {
          const monthData = counterparty.data.find(d => d.month === month);
          row[`${month.toLowerCase()}DebitAmount`] = monthData?.debitAmount || 0;
          row[`${month.toLowerCase()}DebitTransaction`] = monthData?.debitTxnCount || 0;
          row[`${month.toLowerCase()}CreditAmount`] = monthData?.creditAmount || 0;
          row[`${month.toLowerCase()}CreditTransaction`] = monthData?.creditTxnCount || 0;
        }
      });

      return row;
    });
  };


  const generateColumnsBasedOnResponse = (months) => {
    return months.map(month => {
      if (month.includes("Total")) {
        return {
          title: `${month}`,
          children: [
            { title: `Credit (${CURRENCY})`, dataIndex: 'totalCreditAmount', key: 'totalCreditAmount', width: 150, align: 'right', className: 'no-wrap-column', render: (text) => <CustomAmountText value={text} />, },
            { title: `Credit Transaction`, dataIndex: 'totalCreditTransaction', key: 'totalCreditTransaction', width: 150, align: 'center', },
            { title: `Debit (${CURRENCY})`, dataIndex: 'totalDebitAmount', key: 'totalDebitAmount', width: 150, align: 'right', className: 'no-wrap-column', render: (text) => <CustomAmountText value={text} />, },
            { title: `Debit Transaction`, dataIndex: 'totalDebitTransaction', key: 'totalDebitTransaction', width: 150, align: 'center', },
          ]
        };
      } else {

        return {
          title: month,
          children: [
            { title: `Credit (${CURRENCY})`, dataIndex: `${month.toLowerCase()}CreditAmount`, key: `${month.toLowerCase()}CreditAmount`, width: 150, align: 'right', className: 'no-wrap-column', render: (text) => <CustomAmountText value={text} />, },
            { title: `Credit Transaction`, dataIndex: `${month.toLowerCase()}CreditTransaction`, key: `${month.toLowerCase()}CreditTransaction`, width: 150, align: 'center', },
            { title: `Debit (${CURRENCY})`, dataIndex: `${month.toLowerCase()}DebitAmount`, key: `${month.toLowerCase()}DebitAmount`, width: 150, align: 'right', className: 'no-wrap-column', render: (text) => <CustomAmountText value={text} />, },
            { title: `Debit Transaction`, dataIndex: `${month.toLowerCase()}DebitTransaction`, key: `${month.toLowerCase()}DebitTransaction`, width: 150, align: 'center', },
          ]
        };
      }
    });
  };

  return (
    <div>
      {/* <Search
        placeholder="Search in the table"
        style={{ width: 300, marginBottom: 16 }}
      /> */}

      <Table
        dataSource={monthlyCounterparty}
        columns={columns}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 2000 }}
        rowKey="counterparty"
      />
    </div>
  );
};

export default MonthlyCounterparty;